import Icon from '@msi/cobalt-react/icon';
import Button from '@msi/cobalt-react/button';
import {useNavigate} from 'react-router-dom';
import { useEffect, useContext } from 'react';
import BatchUpload from '../BatchUpload/BatchUpload';
import './TableHeader.css'
import { BatchUploadContext } from '../BatchUpload/BatchUploadContext';
import { Tooltip } from 'bootstrap';

interface TableHeaderProps {
    exportDisabled?: boolean;
    onExport?: () => void;
    onGetUpdates?: () => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ exportDisabled = true, onExport, onGetUpdates }) => {
    const navigate = useNavigate();
    const { setShowBatchUpload } = useContext(BatchUploadContext);

    useEffect(() => {
        const tooltipElements = document.querySelectorAll('.page_header_actions [data-bs-toggle="tooltip"]');
        const tooltipInstances: Tooltip[] = [];
        tooltipElements.forEach((el) => {
            // Dispose existing tooltip if any
            const existing = Tooltip.getInstance(el);
            if (existing) existing.dispose();
            tooltipInstances.push(new Tooltip(el));
        });
        return () => {
            tooltipInstances.forEach((instance) => instance.dispose());
        };
    }, [exportDisabled]);

    return (
        <>
            <div className='page_header'>
                <Icon name='ic_data_table' size={36} color='primary' />
                <div className='page_header_text'>
                    <p className='page_title'>API Hub</p>
                    <p className='page_subtitle'>Table view</p>
                </div>
                <div className='page_header_actions'>
                    <Button text='Add API' className='addAPI' onClick={() => navigate("/add-record")} />
                    <Button
                        text="Batch Upload"
                        className='batchUpload'
                        buttonType='action'
                        onClick={() => setShowBatchUpload(true)}
                    />
                    <span
                        {...(exportDisabled ? {
                            'data-bs-toggle': 'tooltip',
                            'data-bs-placement': 'bottom',
                            'data-bs-custom-class': 'custom-tooltip',
                            'data-bs-title': 'Select APIs to get updates',
                        } : {})}
                    >
                        <Button
                            className='getUpdates'
                            buttonType='action'
                            disabled={exportDisabled}
                            onClick={onGetUpdates}
                        >
                            <Icon name="ic_notifications" size={14} color="currentColor" />
                            Get Updates
                        </Button>
                    </span>
                    <span
                        {...(exportDisabled ? {
                            'data-bs-toggle': 'tooltip',
                            'data-bs-placement': 'bottom',
                            'data-bs-custom-class': 'custom-tooltip',
                            'data-bs-title': 'Select APIs to export',
                        } : {})}
                    >
                        <Button
                            className='exportTable'
                            buttonType='action'
                            disabled={exportDisabled}
                            onClick={onExport}
                        >
                            <Icon name="ic_download" size={14} color="currentColor" />
                            Export
                        </Button>
                    </span>
                </div>
            </div>
        </>
    );

};
export default TableHeader;